export default __webpack_public_path__ + "navigation-examples-route-lines-styling-thumbnail-480-82856c1e418dfd850238cd5b0129d7d8.webp";